import gql from 'graphql-tag';

export const getOneEvent = gql`
  query Event($id: ID!) {
    data: Event(id: $id) {
      id
      name
      plot {
        id
        name
        image {
          url
        }
      }
      eventLocationId {
        id
        name
      }
      customLocationDescription
      eventLocation {
        id
        name
      }
      eventDirector {
        id
        firstName
        lastName
        email
        role
        name
      }
      evidenceCode1
      evidenceCode2
      evidenceCode3
      evidenceCode4
      evidenceCode5
      evidenceCode6
      evidenceCode7
      evidenceCode8
      evidenceCode9
      evidenceCode10
      evidenceUnlock1
      evidenceUnlock2
      evidenceUnlock3
      evidenceUnlock4
      evidenceUnlock5
      evidenceUnlock6
      evidenceUnlock7
      evidenceUnlock8
      evidenceUnlock9
      evidenceUnlock10
      numberOfEvidence
      bypassCode
      suspectsCode
      discountCode
      attendingActors
      eventCode
      eventCatId
      plotImage {
        url
      }
      status
      dressCode
      eventDate {
        date
        time
      }
      eventDateISO
      plotIntroduction
      createdAt
      updatedAt
      deletedAt
    }
  }
`;
